<template>
	<div>
		<div class="box-detail-bae right-shadow white">
			<transition name="slide-fade">
				<div class="content-detail-bae" v-if="infoExpedition">
					<v-col cols="12" class="px-4 pb-4">
						<div class="d-flex justify-space-between">
							<div class="text-h6">Informasi Ekspedisi</div>
							<div class="cursor-pointer my-auto" @click="hideInfoExpedition">
								<v-icon>mdi-chevron-left</v-icon>
							</div>
						</div>
					</v-col>
					<div class="list-expedition">
						<div class="px-4"><v-divider></v-divider></div>
						<div class="px-4 py-5 text-body-2">
							<v-row>
								<v-col cols="6" class="pt-0 pb-2 pr-0">Nomor Ekspedisi</v-col>
								<v-col cols="6" class="pt-0 pb-2 pl-0 d-flex">
									<div>:</div>
									<div class="pl-2">0002</div>
								</v-col>
								<v-col cols="6" class="pt-0 pb-2 pr-0">Hari / Tanggal</v-col>
								<v-col cols="6" class="pt-0 pb-2 pl-0 d-flex">
									<div>:</div>
									<div class="pl-2">Selasa / 31 Oktober 2020 08:00</div>
								</v-col>
								<v-col cols="6" class="pt-0 pb-2 pr-0">Jumlah Pengiriman</v-col>
								<v-col cols="6" class="pt-0 pb-2 pl-0 d-flex">
									<div>:</div>
									<div class="pl-2">5 Destinasi</div>
								</v-col>
								<v-col cols="6" class="pt-0 pb-2 pr-0">Jumlah Muatan</v-col>
								<v-col cols="6" class="pt-0 pb-2 pl-0 d-flex">
									<div>:</div>
									<div class="pl-2">235</div>
								</v-col>
								<v-col cols="6" class="pt-0 pb-2 pr-0">Tipe Armada</v-col>
								<v-col cols="6" class="pt-0 pb-2 pl-0 d-flex">
									<div>:</div>
									<div class="pl-2">Tronton</div>
								</v-col>
								<v-col cols="6" class="pt-0 pb-2 pr-0">Plat</v-col>
								<v-col cols="6" class="pt-0 pb-2 pl-0 d-flex">
									<div>:</div>
									<div class="pl-2">AB 001 ML</div>
								</v-col>
								<v-col cols="6" class="pt-0 pb-2 pr-0">Driver</v-col>
								<v-col cols="6" class="pt-0 pb-2 pl-0 d-flex">
									<div>:</div>
									<div class="pl-2">Isa</div>
								</v-col>
								<v-col cols="6" class="pt-0 pb-2 pr-0">Helper</v-col>
								<v-col cols="6" class="pt-0 pb-2 pl-0 d-flex">
									<div>:</div>
									<div class="pl-2">Rio</div>
								</v-col>
							</v-row>
						</div>
						<div class="px-4"><v-divider></v-divider></div>
						<div class="px-4 py-5 text-body-2">
							<v-row>
								<v-col cols="3" class="pr-4">
									<div class="primary lighten-1 rounded-pill">
										<v-icon color="white" class="pa-3">mdi-truck-fast-outline</v-icon>
									</div>
									<div class="line-status-logistic mx-auto"></div>
									<div class="primary lighten-1 rounded-pill">
										<v-icon color="white" class="pa-3">mdi-truck-check-outline</v-icon>
									</div>
									<div class="line-status-logistic mx-auto"></div>
									<div class="primary lighten-1 rounded-pill">
										<v-icon color="white" class="pa-3">mdi-package-variant-closed</v-icon>
									</div>
								</v-col>
								<v-col cols="9" class="pl-0">
									<div class="pt-1 pb-3">
										<div class="text-body-2">Perjalanan ke Mobile Counter</div>
										<div class="text-body-2 grey--text text--darken-1">30 November 2020 22.00</div>
									</div>
									<div class="pt-5 pb-3">
										<div class="text-body-2">Berangkat dari RDC</div>
										<div class="text-body-2 grey--text text--darken-1">30 November 2020 17.00</div>
									</div>
									<div class="pt-5">
										<div class="text-body-2">Loading in produk</div>
										<div class="text-body-2 grey--text text--darken-1">30 November 2020 15.00</div>
									</div>
								</v-col>
							</v-row>
						</div>
					</div>
				</div>
			</transition>
			<transition name="slide-fade">
				<div class="content-detail-bae" v-if="listDelivery">
					<v-col cols="12" class="px-4 pb-4">
						<div class="d-flex justify-space-between">
							<div class="text-h6">Pengiriman</div>
							<div class="cursor-pointer my-auto" @click="hideInfoExpedition">
								<v-icon>mdi-chevron-left</v-icon>
							</div>
						</div>
					</v-col>
					<div class="px-4"><v-divider></v-divider></div>
					<div class="pt-5">
						<div class="px-4 text-body-2 list-expedition">
							<v-card elevation="3" class="px-3 mb-3 rounded-lg" v-for="i in 5" :key="i+'a'">
								<v-row>
									<v-col cols="12">
										<div>Nomor Pengiriman</div>
										<div class="font-weight-bold">SDO0876546763</div>
									</v-col>
								</v-row>
								<v-row>
									<v-col cols="6" class="pt-0">
										<div>Penerima</div>
										<div class="font-weight-bold">Isa</div>
									</v-col>
									<v-col cols="6" class="pt-0">
										<div>Jumlah</div>
										<div class="font-weight-bold">100</div>
									</v-col>
								</v-row>
								<v-row>
									<v-col cols="12" class="pt-0">
										<div>Tujuan</div>
										<div class="font-weight-bold">D.I Yogyakarta</div>
									</v-col>
								</v-row>
								<div class="pt-2 pb-4">
									<v-btn text small tile class="text-capitalize px-2 border-bottom" @click="switchDetailDelivery">
										<span>Detail</span>
										<v-icon>mdi-chevron-right</v-icon>
									</v-btn>
								</div>
							</v-card>
						</div>
					</div>
				</div>
			</transition>
			<transition name="slide-fade">
				<div class="content-detail-bae" v-if="detailDelivery">
					<v-col cols="12" class="px-4 pb-4">
						<div class="d-flex justify-space-between">
							<div class="text-h6">Detail Pengiriman</div>
							<div class="cursor-pointer my-auto" @click="hideInfoExpedition">
								<v-icon>mdi-chevron-left</v-icon>
							</div>
						</div>
					</v-col>
					<div class="px-4"><v-divider></v-divider></div>
					<div class="pt-5">
						<div class="px-4 text-body-2 list-expedition">
							<v-card elevation="3" class="px-3 mb-3 rounded-lg">
								<v-row>
									<v-col cols="12">
										<div>Nomor Pengiriman</div>
										<div class="font-weight-bold">SDO0876546763</div>
									</v-col>
								</v-row>
								<v-row>
									<v-col cols="12" class="pt-0">
										<div>Penerima</div>
										<div class="font-weight-bold">Isa</div>
									</v-col>
								</v-row>
								<v-row>
									<v-col cols="12" class="pt-0">
										<div>Tujuan</div>
										<div class="font-weight-bold">D.I Yogyakarta</div>
									</v-col>
								</v-row>
								<v-row>
									<v-col cols="12" class="pt-0">
										<div>Alamat</div>
										<div class="font-weight-bold">Jl Mawar No 99</div>
									</v-col>
								</v-row>
								<v-row>
									<v-col cols="12" class="pt-4 pb-2">
										<div>Detail Muatan</div>
									</v-col>
									<v-col cols="12" class="pt-0 pb-4">
										<v-card elevation="3" class="rounded-lg mb-3" v-for="i in 3" :key="i">
											<div class="pa-2 d-flex">
												<v-img max-width="50" max-height="50" class="rounded-lg" src="/assets/produk/produk-milagros-water-ro-big.png"></v-img>
												<div class="my-auto pl-2">
													<div>Milagros Drinking Water</div>
													<div class="font-weight-bold">45</div>
												</div>
											</div>
										</v-card>
									</v-col>
								</v-row>
							</v-card>
						</div>
					</div>
				</div>
			</transition>
			<div class="btn-nav-bae" v-if="infoExpedition || listDelivery">
				<div class="d-flex justify-center">
					<v-card elevation="5" width="120" :color="infoExpedition ? 'primary lighten-1' : 'white'" class="cursor-pointer rounded-lg py-2 text-center" :class="infoExpedition ? 'white--text' : 'grey--text'" @click="switchInfoExpedition">
						<div class="px-2 d-flex">
							<div><v-icon :color="infoExpedition ? 'white' : 'grey'">mdi-map-marker-radius</v-icon></div>
							<div class="font-size-10 pl-3 my-auto">Ekspedisi</div>
						</div>
					</v-card>
					<v-card elevation="5" width="120" :color="listDelivery ? 'primary lighten-1' : 'white'" class="cursor-pointer rounded-lg py-2 text-center ml-2" :class="listDelivery ? 'white--text' : 'grey--text'" @click="switchExpedition">
						<div class="px-2 d-flex">
							<div><v-icon :color="listDelivery ? 'white' : 'grey'">mdi-truck-fast-outline</v-icon></div>
							<div class="font-size-10 pl-3 my-auto">Pengiriman</div>
						</div>
					</v-card>
				</div>
			</div>
			<div class="btn-nav-expedition px-4" v-if="detailDelivery">
				<v-btn block large outlined color="grey darken-1" @click="switchDetailDelivery">
					<v-icon>mdi-arrow-left</v-icon>
					<span class="pl-3 text-capitalize">Kembali</span>
				</v-btn>
			</div>
		</div>
	</div>
</template>

<script>

export default {
	components: {
	},
	data () {
		return {
			listDelivery: false,
			detailDelivery: false,
			infoExpedition: true,
		}
	},
	methods: {
		hideInfoExpedition() {
			this.$emit('action')
		},
		switchInfoExpedition() {
			this.infoExpedition = true
			this.listDelivery = false
		},
		switchExpedition() {
			this.infoExpedition = false
			this.listDelivery = true
		},
		switchDetailDelivery() {
			if (this.detailDelivery) {
				this.detailDelivery = false
				this.listDelivery = true
				this.infoExpedition = false
			} else {
				this.detailDelivery = true
				this.listDelivery = false
				this.infoExpedition = false
			}
		}
	}
};
</script>